import * as React from 'react';
import { routes } from '../../../../../config/routes';
import { Logo } from '../../../../../components/app/logo/logo';
import { HeaderBackButton } from '../../../../../components/app/header/back-button/header-back-button';
import { HeaderPinSharedPortfolioButton } from '../../../../../components/app/header/pin-shared-portfolio-button/header-pin-shared-portfolio-button';

export const HeaderVerticalShared: React.FC = () => {
    return (
        <div className="z-[900] flex items-center justify-between border-b border-border bg-surface/90 px-medium backdrop-blur-[0.5rem]">
            <div className="flex items-center gap-xsmall md:gap-vsmall">
                <Logo href={routes.app.index} inApp />
            </div>
            <div className="flex items-center gap-vsmall py-vsmall">
                <HeaderPinSharedPortfolioButton />
                <HeaderBackButton />
            </div>
        </div>
    );
};
